import React from "react";
// import TableComandas from "../components/TableComandas";
import AppCajaReactTable from "../table/AppCajaReactTable";

import Footer from "../components/Footer";

import "../css/footer.css";

const Cajas = () => {
  return (
    <>
      <AppCajaReactTable />
      {/* <TableComandas /> */}
      <Footer />
    </>
  );
};

export default Cajas;
